module.exports = __webpack_public_path__ + "static/media/anniu2.a9328f9b.png";